import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useCreatePtoEntry } from "@/hooks/use-pto-entries";
import { PtoEntryForm } from "./PtoEntryForm";

interface PtoEntryCreateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Create dialog — wraps the shared PtoEntryForm. Triggered from the table toolbar. */
export function PtoEntryCreateDialog({ open, onOpenChange }: PtoEntryCreateDialogProps) {
  const createEntry = useCreatePtoEntry();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>New PTO entry</DialogTitle>
          <DialogDescription>Add a vacation, sick, or other time-off entry.</DialogDescription>
        </DialogHeader>
        <PtoEntryForm
          submitLabel="Create"
          isSaving={createEntry.isPending}
          onCancel={() => onOpenChange(false)}
          onSubmit={(result) =>
            createEntry.mutate(result, { onSuccess: () => onOpenChange(false) })
          }
        />
      </DialogContent>
    </Dialog>
  );
}
